module.exports = __webpack_public_path__ + "staticcomp/img/content_2plural.6e4545d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_2plural.jpg
// module id = mf3K
// module chunks = 39